export default __webpack_public_path__ + "static/media/img-decoration.88448042.svg";